import { faAngleUp, faAngleDown } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

import { SORT_DIRECTION, SortDirection } from '../../../../DomainPresentation/utils'

import { SortEntity, SortIcon } from './PaginatedCheckboxModal.styled'
import { IconProp } from '@fortawesome/fontawesome-svg-core'

interface SortContainerProps {
  children: React.ReactNode
  onCLick: () => void
  direction: SortDirection
}

export const SortContainer: React.FC<SortContainerProps> = ({ children, direction, onCLick }) => {
  return (
    <SortEntity onClick={onCLick}>
      {children}
      <SortIcon>
        <FontAwesomeIcon
          icon={
            direction === SORT_DIRECTION.ASC ? (faAngleUp as IconProp) : (faAngleDown as IconProp)
          }
        />
      </SortIcon>
    </SortEntity>
  )
}
